module.exports = __webpack_public_path__ + "img/shortcut_chat_off.c0633705.svg";